import { render, staticRenderFns } from "./CompanyItem.vue?vue&type=template&id=99c208c8&scoped=true&lang=pug&"
import script from "./CompanyItem.vue?vue&type=script&lang=ts&"
export * from "./CompanyItem.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyItem.vue?vue&type=style&index=0&id=99c208c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c208c8",
  null
  
)

export default component.exports